const hasEle = (arr, ele) => {
  let flag = false;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] == ele) {
      //表示元素ele在数组arr中存在
      flag = true;
      break;
    }
  }
  return flag;
}
const noRepeat = (arr) => {
  //创建一个空数组，用来保存去重后的元素
  let newArr = [];
  //遍历原数组中的每一个元素
  for (let i = 0; i < arr.length; i++) {
    //拿到每一个元素与newArr比较，凑数newArr里是否存在这些元素，如果不存在就添加
    if (!hasEle(newArr, arr[i])) {
      newArr.push(arr[i]);
    }
  }
  return newArr;
}

// replace(/(\d)(?=(\d{3})+($|\.))/g, '$1,')、
// const moneyFormat = function (value) { // 金额 格式化
//   if (!value && value !== 0) return '-';
//   let intPart = Number(value) | 0; //获取整数部分
//   let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
//
//   let floatPart = ".00"; //预定义小数部分
//   let value2Array = value.toString().split(".");
//
//   //=2表示数据有小数位
//   if (value2Array.length == 2) {
//     floatPart = value2Array[1].toString(); //拿到小数部分
//
//     if (floatPart.length == 1) { //补0,实际上用不着
//       return intPartFormat + "." + floatPart + '0';
//     } else {
//       return intPartFormat + "." + floatPart;
//     }
//   } else {
//     return intPartFormat + floatPart;
//   }
// }
// moneyFormat(Math.abs(text) / 100)

const idToName = (list, id) => {
  let name = '';
  if (list && list.length > 0) {
    list.map((i) => {
      if (i.id == id) {
        name = i.name;
      }
    })
  }
  return name;
}

const getTreeName = (list, id) => {
  if (list && list.length > 0) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === id) {
        return list[i].name
      } else if (list[i].children && list[i].children.length > 0) {
        let res = getTreeName(list[i].children, id)
        if (res) {
          return res
        }
      }
    }
  }
}

const treeToList = (tree, type) => {
  let newArr = [];
  if (tree && tree.length > 0) {
    tree.map((item) => {
      let obj = {...item};
      if (item[type] && item[type].length > 0) {
        item[type].map((i) => {
          newArr.push({...i, ...obj,});
        })
      }
    })
  }
  return newArr;
}


// 查找所有父节点
const getAllParentArr = (list, id) => {
  for (let i in list) {
    if (list[i].id == id) {
      //查询到返回该数组对象
      return list[i].name;
    }
    if (list[i].children) {
      let node = getAllParentArr(list[i].children, id);
      if (node != undefined) {
        //查询到把父节点连起来
        return list[i].name + '/' + node;
      }
    }
  }
}

//供应商和生产商汉化
const handleIdToName = (id, list) => {
  let name = '';
  if (id && list && list.length > 0) {
    list.map((i) => {
      if (i.id == id) {
        name = i.name;
      }
    })
  }
  return name;
}
/*const priceFormat = (num, decimal = 6) => {
  if (!num) return '';
  num = num[num.length - 1] === '.' && num.match(/\./g).length === 1 ? num : parseFloat(num) //isNaN(parseFloat(num)) ? '' : parseFloat(num).toString();
  // num = typeof num != 'String' ? num.toString() : num;
  if(isNaN(num)) return'';

  num = num.toString();
  // 初次阻止0-9及.以外的字符
  if (!/^[0-9,.]*$/.test(num)) return num.slice(0, -1)

  const reg = /^(([1-9][0-9]*\.[0-9][0-9]?)|([0]\.[0-9][0-9]?)|([1-9][0-9]*)|([0]{1}))$/;
  if (!reg.test(num) && num.match(/\./g).length > 1) {
    num = num.slice(0, -1)
  } else if (num.includes('.') && num.match(/\./g).length > 1) {
    num = num.slice(0, -1)
  } else if (num.includes('.') && !parseInt(decimal)) {
    num = num.slice(0, -1)
  } else if (num.includes('.') && num.split('.')[1].length > decimal) {
    num = num.slice(0, -1)
  }

  if (num.includes('.')) {
    const index = num.indexOf('.');
    const len = num.length;
    return len - 1 - index > decimal ? num.slice(0, index + decimal + 1) : num
  } else {
    return num;
  }
}*/

//金额
const priceFormat = (num, n) => {
  n = n || 2;
  let symbol = ",";
  if (!num && num !== 0) return '';
  // if (num === null) return '-';
  if (num == undefined) return num;
  if (typeof num != 'number') {
    if (typeof num == 'string') num = delcommafy(num);
    num = Number(num)
  }
  // if (num <= 0)
  if (n < 0) throw new Error('参数n不应该小于0');
  let hasDot = parseInt(num) != num;//这里检测num是否为小数，true表示小数
  let m = (n != undefined && n != null) ? n : 1;
  num = m == 0 ? num.toFixed(m) + '.' : hasDot ? (n ? num.toFixed(n) : num) : num.toFixed(m);
  symbol = symbol || ',';
  num = num.toString().replace(/(\d)(?=(\d{3})+\.)/g, function (match, p1, p2) {
    return p1 + symbol;
  });
  if (n == 0 || (!hasDot && !n)) {//如果n为0或者传入的num是整数并且没有指定整数的保留位数，则去掉前面操作中的小数位
    num = num.substring(0, num.indexOf('.'));
  }
  return num;
}

//数量千分位（保留6位小数）
const quantityFormat = (num, n) => {
  n = n || 6;
  let symbol = ",";
  if (!num && num !== 0) return '';
  // if (num === null) return '-';
  if (num == undefined) return num;
  if (typeof num != 'number') {
    if (typeof num == 'string') num = delcommafy(num);
    num = Number(num);
  }
  // if (num <= 0)
  if (n < 0) throw new Error('参数n不应该小于0');

  let hasDot = parseInt(num) != num;//todo 这里检测num是否为小数，true表示小数

  let m = (n != undefined && n != null) ? n : 1;//todo 确定保留几位小数

  num = m == 0 ? num.toFixed(m) + '.' : hasDot ? (n ? num.toFixed(n) : num) : num.toFixed(m);//整数与小数
  //todo 后面的0000去掉（最多保留2个0）
  if (num.split('.')[1].endsWith('0000')) {
    num = num.split('.')[0] + '.' + num.split('.')[1].substr(0, 2);
  }
  if (num.split('.')[1].endsWith('000')) {
    num = num.split('.')[0] + '.' + num.split('.')[1].substr(0, 3);
  }
  if (num.split('.')[1].endsWith('00')) {
    num = num.split('.')[0] + '.' + num.split('.')[1].substr(0, 4);
  }
  if (num.split('.')[1].endsWith('0')) {
    num = num.split('.')[0] + '.' + num.split('.')[1].substr(0, 5);
  }

  symbol = symbol || ',';
  num = num.toString().replace(/(\d)(?=(\d{3})+\.)/g, function (match, p1, p2) {
    return p1 + symbol;
  });
  if (n == 0 || (!hasDot && !n)) {//todo 如果n为0或者传入的num是整数并且没有指定整数的保留位数，则去掉前面操作中的小数位
    num = num.substring(0, num.indexOf('.'));
  }
  return num;
}

//去除千分位中的‘，’
const delcommafy = (num) => {
  // if (!num || num <= 0) return num;
  if (!num || num < 0) return num;
  num = num.toString();
  num = num.replace(/,/gi, '');
  if (num.indexOf('.000000') > 0) num = parseInt(num);
  return Number(num);
}
//乘
const accMul = (arg1, arg2) => {
  let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length
  } catch (e) {
  }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}
//加
const numberAdd = (num1, num2) => {
  let r1, r2, m
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (num1 * m + num2 * m) / m
}
/*const numberAdd = function (arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  n = (r1 >= r2) ? r1 : r2;
  return parseInt(((arg1 * m + arg2 * m) / m).toFixed(6));
}*/
//减
/*const numberSub = (num1, num2) => {
  let r1, r2, m
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))

  // 动态控制精度长度
  // n = (r1 = r2) ? r1 : r2;

  return (num1 * m - num2 * m) / m
}*/
const numberSub = function (arg1, arg2) {
  let re1, re2, m, n;
  try {
    re1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    re1 = 0;
  }
  try {
    re2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    re2 = 0;
  }
  m = Math.pow(10, Math.max(re1, re2));
  n = (re1 >= re2) ? re1 : re2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

//除
const numberDiv = function (arg1, arg2, digit) {
  let t1 = 0, t2 = 0, r1, r2;
  try {
    t1 = arg1.toString().split(".")[1].length
  } catch (e) {
  }
  try {
    t2 = arg2.toString().split(".")[1].length
  } catch (e) {
  }
  r1 = Number(arg1.toString().replace(".", ""))
  r2 = Number(arg2.toString().replace(".", ""))
  //获取小数点后的计算值
  let result = ((r1 / r2) * Math.pow(10, t2 - t1)).toString()
  let result2 = result.split(".")[1];
  result2 = result2.substring(0, digit > result2.length ? result2.length : digit);

  return Number(result.split(".")[0] + "." + result2);
}

const handleTips = (url, method) => {
  let title = null;
  if (method == 'put') {
    //终止等
    // if (url.indexOf('/stop') !== -1) title = '确定要终止吗?';
    if (url.indexOf('/invite-code/out') !== -1) title = '确定要禁用邀请吗?';
    if (url.indexOf('/user/out') !== -1) title = '确定停用吗?';
    if (url.indexOf('/invalidate') !== -1) title = '确定要作废单据吗?';
    if (url.indexOf('/ticketcollector') !== -1) title = '确定要作废票据吗?';
    if (url.indexOf('/ticketstart') !== -1) title = '确定要作废票据吗?';
  }
  if (method == 'post') {
    if (url.indexOf('/refresh-code') !== -1) title = '更新邀请码后原邀请码失效！';
  }
  if (method == 'delete') {
    if (url.indexOf('/logout') !== -1) {
      title = '确定要退出登录吗？'
    } else if (url.indexOf('/logQuit') !== -1) {
      //todo nothing
    } else if (url.indexOf('/ticketcollector') !== -1 || url.indexOf('/ticketstart') !== -1) {
      title = '确定要作废吗？'
    } else {
      //删除等
      title = '确定要删除吗？'
    }
  }
  return title;
}

const mobileStr = (tab) => {
  if (tab.length > 7) {
    return tab.substring(0, 3) + '****' + tab.substring(7, tab.length);
  } else {
    return tab.substring(0, tab.length - 1) + '****';
  }
}
const checkPassword = (str) => {
  // 第一步先判断各分类长度
  let num = 0;//数字
  let lowerCase = 0;//小写字母
  let upperCase = 0;//大写字母
  let special = 0;//特殊字符
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i)
    if (c >= 48 && c <= 57) {
      //数字
      num++;
    } else if (c >= 65 && c <= 90) {
      //大写字母
      upperCase++;
    } else if (c = 97 && c <= 122) {
      //小写字母
      lowerCase++;
    } else {
      special++;
    }
  }
  // 第二步 计算分数
  let wholeMark = 0
  let numMark = 0
  let caseMark = 0
  let specialMark = 0
  let reward = 0
  // 整长度分数
  if (str.length <= 4) {
    wholeMark = 5
  } else if (str.length > 4 && str.length <= 8) {
    wholeMark = 10
  } else {
    wholeMark = 25
  }
  // 奖励分数
  if ((lowerCase || upperCase) && num) {
    reward = 2
    if (special) {
      reward = 3
      if (lowerCase && upperCase) {
        reward = 5
      }
    }
  }
  // 字母分数
  if (lowerCase || upperCase) {
    caseMark = 10
    if (lowerCase && upperCase) {
      caseMark = 20
    }
  }
  // 数字分数
  if (num) {
    numMark = 10
    if (num >= 3) {
      numMark = 20
    }
  }
  // 符号分数
  if (special) {
    specialMark = 10
    if (special > 1) {
      specialMark = 25
    }
  }
  let totalMark = wholeMark + numMark + caseMark + specialMark + reward
  let strength = ''
  if (totalMark < 25) {
    strength = '非常弱'
  } else if (totalMark >= 25 && totalMark < 50) {
    strength = '弱'
  } else if (totalMark >= 50 && totalMark < 60) {
    strength = '一般'
  } else if (totalMark >= 60 && totalMark < 70) {
    strength = '强'
  } else if (totalMark >= 70 && totalMark < 80) {
    strength = '非常强'
  } else if (totalMark >= 86 && totalMark < 90) {
    strength = '安全'
  } else {
    strength = '非常安全'
  }
  return strength
}
const dealImage = (base64, w, proportion, callback) => {
  let newImage = new Image();
  let quality = 0.8;    //压缩系数0-1之间
  let size = proportion ? proportion : 1;
  newImage.src = base64;
  newImage.setAttribute("crossOrigin", 'Anonymous');	//url为外域时需要
  let imgWidth, imgHeight;
  newImage.onload = function () {
    //this指的是图片信息
    imgWidth = this.width;
    imgHeight = this.height;
    // console.log(imgWidth, imgHeight, '宽高')
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    // console.log(Math.max(imgWidth, imgHeight), Math.min(imgWidth, imgHeight));
    if (size > 1) {
      if (Math.min(imgWidth, imgHeight) > w) {
        if (imgWidth > imgHeight && imgWidth / imgHeight > size) {
          canvas.height = w;
          canvas.width = w * imgWidth / imgHeight;
        } else if ((imgWidth > imgHeight && imgWidth / imgHeight < size)) {
          canvas.width = w;
          canvas.height = w * imgHeight / imgWidth;
        } else if (imgWidth < imgHeight && imgWidth / imgHeight > size) {
          canvas.width = w;
          canvas.height = w * imgHeight / imgWidth;
        } else if (imgWidth < imgHeight && imgWidth / imgHeight < size) {
          canvas.width = w;
          canvas.height = w * imgHeight / imgWidth;
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
          quality = 0.8;
        }
      }
    } else {
      if (Math.min(imgWidth, imgHeight) > w) {
        if (imgWidth > imgHeight) {
          canvas.height = w;
          canvas.width = w * imgWidth / imgHeight;
        } else {
          canvas.width = w;
          canvas.height = w * imgHeight / imgWidth;
        }
      } else {
        canvas.width = imgWidth;
        canvas.height = imgHeight;
        quality = 0.8;
      }
    }
    // console.log(canvas.width, canvas.height,'最终宽高')
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
    let base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
    //todo  如想确保图片压缩到自己想要的尺寸,如要求在100kb以下，请加以下语句，quality初始值根据情况自定
    while (base64.length / 1024 > 100) {
      quality -= 0.01;
      base64 = canvas.toDataURL("image/jpeg", quality);
    }
    callback(base64);//必须通过回调函数返回，否则无法及时拿到该值
  }
}

const dealImage1 = (base64, w, callback) => {
  let newImage = new Image();
  let quality = 0.8;    //压缩系数0-1之间
  newImage.src = base64;
  newImage.setAttribute("crossOrigin", 'Anonymous');	//url为外域时需要
  let imgWidth, imgHeight;
  newImage.onload = function () {
    //this指的是图片信息
    imgWidth = this.width;
    imgHeight = this.height;
    console.log(imgWidth, imgHeight)
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    // console.log(Math.max(imgWidth, imgHeight), Math.min(imgWidth, imgHeight));
    if (Math.min(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.height = w;
        canvas.width = w * imgWidth / imgHeight;
      } else {
        canvas.width = w;
        canvas.height = w * imgHeight / imgWidth;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
      quality = 0.8;
    }
    console.log(canvas.width, canvas.height)
    /* if (Math.max(imgWidth, imgHeight) > w) {
       if (imgWidth > imgHeight) {
         canvas.width = w;
         canvas.height = w * imgHeight / imgWidth;
       } else {
         canvas.height = w;
         canvas.width = w * imgWidth / imgHeight;
       }
     } else {
       canvas.width = imgWidth;
       canvas.height = imgHeight;
       quality = 0.6;
     }*/
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
    let base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
    //todo  如想确保图片压缩到自己想要的尺寸,如要求在100kb以下，请加以下语句，quality初始值根据情况自定
    while (base64.length / 1024 > 100) {
      quality -= 0.01;
      base64 = canvas.toDataURL("image/jpeg", quality);
    }
    callback(base64);//必须通过回调函数返回，否则无法及时拿到该值
  }
}

//todo 根据图片base64位信息获取图片宽高
const base64GetWH = (base64) => {
  let newImage = new Image();
  // 这里将src传入需要获取信息的图片地址或base64
  newImage.src = base64;
  // onload是异步的,封装的话可以用promise
  newImage.onload = () => {
    // 输出图片信息 比如可以获取图片宽高
    console.log(newImage.width);
    console.log(newImage.height);
  }
}
const showApproveMethod = (list, type, operation) => {
  let flag = false;
  if (list && list.length > 0) {
    list.map((i) => {
      if (i.moduleCode == type && i.flag) {
        if (i.workFlows && i.workFlows.length > 0) {
          i.workFlows.map((j) => {
            if (j.workflowCode == operation && j.flag) flag = true;
          })
        }
      }
    })
  }
  return flag;
}


// 查找所有父节点
const getAllParentIDArr = (list, id) => {
  for (let i in list) {
    if (list[i].id == id) {
      //查询到返回该数组对象
      return [list[i].id];
    }
    if (list[i].children) {
      let node = getAllParentIDArr(list[i].children, id);
      if (node !== undefined) {
        //查询到把父节点连起来
        return node.concat(list[i].id);
      }
    }
  }
}

//todo  处理路径拼接
const handleURL = (params) => {
  let url = '?';
  for (let key in params) {
    if (key && params[key]) url += key + '=' + params[key] + '&';
  }
  url = url.substring(0, url.length - 1)
  return url;
}

//去重复添加
const compareMonth=(arr, data) =>{
  let flag = false;
  if (arr && arr.length > 0) {
    arr.map((i) => {
      if (i.month === data) {
        flag = true;
      }
    })
  }
  if (!flag) {
    arr.push({month:data});
  }
}
//信息归类
const handleData=(arr, data) =>{
  let flag = false;
  if (arr && arr.length > 0) {
    arr.map((i) => {
      if (i === data) {
        flag = true;
      }
    })
  }
  if (!flag) {
    arr.push({month:data});
  }
}

export {
  hasEle,
  noRepeat,
  idToName,
  getAllParentArr,
  handleIdToName,
  priceFormat,
  quantityFormat,
  delcommafy,
  accMul,
  numberAdd,
  numberSub,
  numberDiv,
  handleTips,
  mobileStr,
  checkPassword,
  dealImage,
  base64GetWH,
  showApproveMethod,
  getAllParentIDArr,
  handleURL,
  getTreeName,
  compareMonth,
  handleData,
}



// WEBPACK FOOTER //
// ./src/utils/tool.js